import bemCssModules from 'bem-css-modules';
import { memo } from 'react';

import LoadingModuleCss from './Loading.module.css';

const block = bemCssModules(LoadingModuleCss);

export const Loading = memo(() => (
  <div className={block()}>
    <div className={block('spinner')} />
  </div>
));
